import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PUSH } from 'constants/messageMediums';
import { fetchIntegrations, fetchMobileApps } from 'modules/mobileApps/actions';
import { selectMobileAppsWithIntegrations } from 'modules/mobileApps/selectors';
import BaseSendEditor, { BaseSendEditorProps } from '../BaseSendEditor';

export const SendPushEditor = (props: BaseSendEditorProps) => {
  const dispatch = useDispatch();

  /* Show iOS and Android apps that have push integrations */
  const mobileApps = useSelector(selectMobileAppsWithIntegrations);

  /* Selective push will be visible if there is at least one selectable mobile app */
  const shouldShowSelectivePush = mobileApps?.length > 0;

  useEffect(() => {
    dispatch(fetchMobileApps());
    dispatch(fetchIntegrations());
  }, []);

  return (
    <BaseSendEditor
      shouldShowSTO
      shouldShowDeliverySectionHeader
      shouldShowQuietHours
      shouldShowRateLimit
      {...props}
      shouldShowSelectivePush={shouldShowSelectivePush}
      messageMedium={PUSH}
      mobileApps={mobileApps}
    />
  );
};
